import * as React from 'react'
import { Appbar } from 'react-native-paper'
import { useSetRecoilState } from 'recoil'
import { StyleSheet, View, ViewStyle } from 'react-native'
import { MaterialCommunityIcons, MaterialIcons } from '@expo/vector-icons'
import { NavigationRoute } from '@/main/config/router-navigation'
import { useAuth, useMediaQueries, useThemeClient } from '@/presentation/hooks'
import { Text, LogoTheme, NavigationPagesProps, isOpenUserMenuState, IconButton } from '@/presentation/components'

export const APP_BAR_HEIGTH = 64
export const PADDING_STATUS_BAR_IOS = 24

export const Header: React.FC<NavigationPagesProps> = ({ navigation }) => {
  const { isAdmin } = useAuth()
  const { getThemeClient } = useThemeClient()
  const { openInPWA, openInIOS, isMobile } = useMediaQueries()
  const setOpenUserMenu = useSetRecoilState(isOpenUserMenuState)

  const themeClient = getThemeClient()

  const contentTitleStyle: ViewStyle = {
    alignItems: 'flex-start'
  }

  if (!isMobile || isAdmin()) {
    contentTitleStyle.alignItems = 'center'
  }

  const ContentTitle: React.FC = () => (
    <Appbar.Content
      title={
        <View style={styles.logoArea}>
          <LogoTheme height={40} />
          <Text
            onPress={() => navigation.navigate(NavigationRoute.Home)}
            style={{
              ...styles.title,
              ...(isMobile && { fontSize: 18 })
            }}
            variant='h6'
          >
            Portal do Cliente
          </Text>
        </View>
      }
      style={ contentTitleStyle }
    />
  )

  return (
    <Appbar.Header style={{
      ...styles.appBar,
      backgroundColor: themeClient.mainColor,
      ...(openInPWA && openInIOS && { paddingTop: PADDING_STATUS_BAR_IOS })
    }}>
      <Appbar.Action
        icon={(props: any) => <MaterialCommunityIcons name='menu' {...props}/>}
        onPress={() => navigation.toggleDrawer()}
        isLeading
        testID="menu-geral"
        color={themeClient.menuColor}
      />
      <ContentTitle />
      <IconButton
        color={themeClient.menuColor}
        onPress={() => setOpenUserMenu(true)}
        testID="menu-usuario"
        icon={props => <MaterialIcons name='account-circle' {...props} />}
      />
    </Appbar.Header>
  )
}

const styles = StyleSheet.create({
  appBar: {
    minHeight: APP_BAR_HEIGTH
  },
  logoArea: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row'
  },
  title: {
    color: '#FFF',
    flex: 1
  }
})
